import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Navbar from "components/Navbars/AuthNavbar.js";
import { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { isUserOrganizationDeleted } from "utils/organizationAccess";
import { currentUserHomeRoute } from "utils/referralRouting";

// views

export default function Auth() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const location = useLocation();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    // Show loader for 1 second
    const loaderTimer = setTimeout(() => {
      setShowLoader(false);
    }, 500);

    // Check token in background
    if (token) {
      if (isUserOrganizationDeleted()) {
        if (location.pathname !== "/organization-deleted") {
          navigate("/organization-deleted");
        }
      } else if (
        location.pathname !== "/organization-deleted" &&
        !location.pathname.startsWith("/employee/clock-in")
      ) {
        navigate(currentUserHomeRoute());
      }
    }

    return () => clearTimeout(loaderTimer);
  }, []);

  if (showLoader) {
    return (
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <>
      <main>
        <section className="relative w-full h-full min-h-screen">
          <Outlet />
        </section>
      </main>
    </>
  );
}
